import React from 'react'
import { Spinner } from 'lib/ui/components'
import { ProductCard } from 'components/ProductCard'
import { Container, Loading } from './components/Styled'
import { ProductData } from 'lib/types'

interface Props {
  title: string
  productLinks?: ProductData[]
}

export const ProductList = ({ title, productLinks }: Props) => {
  const products = productLinks

  const isLoaded = products?.length

  if (!products?.length) {
    return null
  }

  return (
    <Container>
      {title && (
        <h3>{title}</h3>
      )}
      {isLoaded ? (
        <div className='products-wrapper'>
          {products?.slice(0, 4).map(product => {
            return (
              <div
                key={product.sku}
                className='item'
              >
                <ProductCard
                  product={product}
                  listPage='Other'
                />
              </div>
            )
          })}
        </div>
      ) : (
        <Loading>
          <Spinner />
        </Loading>
      )}
    </Container>
  )
}
